const modalBackups = {
  title: 'Edit Backup',
  placeholder: 'Search',
  name: 'File Name',
  size: 'Size',
  fileType: 'File type',
  createdAt: 'Created At',
  createdBy: 'Created By',
  ingestedBy: 'Ingested By',
  ingestedAt: 'Ingested At',
  ingested: 'Ingested',
};

export default modalBackups;
